import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import * as React from "react";
import Brightness1Icon from '@mui/icons-material/Brightness1';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import SquareIcon from '@mui/icons-material/Square';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import InterestsIcon from '@mui/icons-material/Interests';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';


export const mappingChelou={
    "83137_0019":{iris:"831370308",proxy:"83137_0067"},
    "83137_19":{iris:"831370308",proxy:"83137_0067"},
}

export const percentageRepresentation = 0.25;

let nu = {
    LEXG: {
        year: [2000, 2014],
        name: ["Liste Extrême gauche", "Extrême gauche"],
        color: "#f40a06"
    },
    LCOM: {
        year: [2000, 2014],
        name: ["Liste Parti communiste français", "Parti communiste français"],
        color: "#f40a06"

    },
    LFI: {
        year: [2000],
        name: ["La France insoumise"],
        color: "#f40a06"
    },
    LFG: {
        year: [2000],
        name: ["Liste Front de Gauche"],
        color: "#f40a06"
    },
    LPG: {
        year: [2000],
        name: ["Liste du Parti de Gauche"],
        color: "#f40a06"
    },
    LSOC: {
        year: [2000,2014],
        name: ["Liste Parti socialiste","Parti socialiste"],
        color: "#f493c4"
    },
    LNUP: {
        year: [2000],
        name: ["NUPES"],
        color: "#f493c4"
    },

    LDVG: {
        year: [2000,2014],
        name: ["Liste Divers gauche","Divers gauche"],
        color: "#f493c4"
    },
    LRDG: {
        year: [2000],
        name: ["Parti radical de gauche"],
        color: "#f493c4"
    },
    LUG: {
        year: [2000,2014],
        name: ["Liste Union de la gauche","Union de la gauche"],
        color: "#f493c4"
    },
    LVEC: {
        year: [2000,2014],
        name: ["Liste Europe Ecologie-Les Verts","Europe Ecologie-Les Verts"],
        color: "#7ed989"
    },
    LECO: {
        year: [2000],
        name: ["Ecologiste"],
        color: "#7ed989"
    },
    LREG: {
        year: [2000],
        name: ["Régionaliste"],
        color: "#d0d0d0"
    },
    LGJ: {
        year: [2000],
        name: ["Gilets jaunes"],
        color: "#f4f210"
    },
    LENS: {
        year: [2000],
        name: ["Ensemble ! (Majorité présidentielle)"],
        color: "#f5b70a"
    },
    LREM: {
        year: [2020],
        name: ["La République en marche"],
        color: "#f5b70a"
    },
    LMDM: {
        year: [2000,2014],
        name: ["Liste Modem","Modem"],
        color: "#f5b70a"
    },
    LUDI: {
        year: [2000,2014],
        name: ["Liste Union des Démocrates et Indépendants","Union des Démocrates et Indépendants"],
        color: "#f5b70a"
    },
    LUC: {
        year: [2000,2014],
        name: ["Liste Union du centre","Union du centre"],
        color: "#f5b70a"
    },
    LDVC: {
        year: [2000],
        name: ["Divers centre"],
        color: "#f5b70a"
    },
    LUMP: {
        year: [2000],
        name: ["Liste Union pour un Mouvement Populaire"],
        color: "#4c8ed0"
    },
    LLR: {
        year: [2000],
        name: ["Les Républicains"],
        color: "#4c8ed0"
    },
    LR: {
        year: [2000],
        name: ["Les Républicains"],
        color: "#4c8ed0"
    },
    LUD: {
        year: [2000, 2014],
        name: ["Liste Union de la droite","Liste Union de la droite"],
        color: "#4c8ed0"
},
    LDVD: {
        year: [2000,2014],
        name: ["Liste Divers droite","Divers droite"],
        color: "#4c8ed0"
    },
    LDLF: {
        year: [2000],
        name: ["Debout la France"],
        color: "#0f2740"
    },
    LFN: {
        year: [2000],
        name: ["Liste Front National"],
        color: "#0f2740"
    },
    LREC: {
        year: [2000],
        name: ["Reconquête !"],
        color: "#0f2740"
    },

    LRN: {
        year: [2000],
        name: ["Rassemblement National"],
        color: "#0f2740"
    },
    LEXD: {
        year: [2000,2014],
        name: ["Liste Extrême droite","Extrême droite"],
        color: "#0f2740"
    },
    LUXD: {
        year: [2000],
        name: ["Union de l'extrême droite"],
        color: "#0f2740"
    },
    LDIV: {
        year: [2000,2014],
        name: ["Liste Divers","Divers"],
        color: "#d0d0d0"
    },

}

function insertionIndex (arr, n){
    const isDescending = arr[0] > arr[arr.length - 1];
    const index = arr.findIndex(el => (isDescending ? n >= el : n <= el));
    return index === -1 ? arr.length : index;
}

export function getLabelFromNuance(nuance, year) {
    if (nuance[0] !== "L") {
        nuance = "L" + nuance;
    }
    if (nu[nuance] === undefined) {
        nuance = "LDIV";
    }
    const infoNuance =nu[nuance];
    let insertionIndex1 = insertionIndex(infoNuance.year, year)-1;

    return {
        name: infoNuance.name[insertionIndex1],
        color: infoNuance.color
    }
}

export function formatNumber(value) {
    return Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 0,
    }).format(value);
}
export function formatPercentage(value) {
    return Intl.NumberFormat("fr-FR", {
        style: "percent",
        minimumFractionDigits: 1,
    }).format(value);
}

export function getPercentage(value, valueOn) {
    return formatPercentage(value / valueOn);
}

export function correctName(name) {
    if(name=== null || name === undefined) {
        return "";
    }
    name = name
        .replaceAll("\"", "")
        .replaceAll("Ã©", "é")
        .replaceAll("d\?r", "dér")
        .replaceAll("\?", "é")
        .replaceAll("Ã§", "ç")
        .replaceAll("Ã©", "é")
        .replaceAll("Ã«", "ë")
        .replaceAll("Ã", "É")
        .replaceAll("Ã", "É")
        .replaceAll("Ã´", "ô")
        .replaceAll("Ã", "Î")
        .replaceAll("Â°", "°")
        .replaceAll("Ã¨", "è")
        .replaceAll("Ã", "Ê")
        .replaceAll("Ã¯", "ï");

    return name;
}


export function getWidth(inscrit, max) {
    let res = (inscrit / max) * 600
    if (res < 1) {
        return 2;
    }
    return res;
}

export function getAugmeneation(tour2, tour22) {
    if (tour2 === null || tour22 === null) {
        return ""
    }
    const res = (tour2 - tour22) / tour22;

    if (res > 0) {
        return "(+ " + ((res) * 100).toFixed(1) + "%)";
    } else {

        return "(" + (res * 100).toFixed(1) + "%)";
    }

}

export function computeN(electionsData) {
    if (Object.keys(electionsData).length <= 3) {
        return Object.keys(electionsData).length
    } else {
        return 3
    }

}

export function stringToColour(str) {
    let hash = 0;
    str.split('').forEach(char => {
        hash = char.charCodeAt(0) + ((hash << 5) - hash)
    })
    let colour = '#'
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xff
        colour += value.toString(16).padStart(2, '0')
    }
    return colour
}


export const labelGagnant = {
    winner: "Large victoire",
    winnerJuste: "Victoire disputée",
    winnerPeu: "Courte défaite",
    winnerLargement: "Large défaite"
}

export const tours = {
    t1: "Premier tour",
    t2: "Deuxième tour",
}


export const tours2 = {
    t1: "1er tour",
    t2: "2eme tour",
}


export function getMinMax(type) {
    if (type === 1) {
        return {min: 5, max: 100, text: labelGagnant.winner};
    }
    if (type === 2) {
        return {min: 0, max: 5, text: labelGagnant.winnerJuste};
    }
    if (type === 3) {
        return {min: -5, max: 0, text: labelGagnant.winnerPeu};
    }
    if (type === 4) {
        return {min: -100, max: -5, text: labelGagnant.winnerLargement};
    }
}

export function getInfoElection(n) {
    if (n > 0.05) {
        return {type: "winner", text: labelGagnant.winner, color: "#0fa64e"};
    } else if (n > 0) {
        return {type: "winnerJuste", text: labelGagnant.winnerJuste, color: "#86c14d"};
    } else if (n > -0.05) {
        return {type: "winnerPeu", text: labelGagnant.winnerPeu, color: "#eeb408"};
    } else {
        return {type: "winnerLargement", text: labelGagnant.winnerLargement, color: "#e70a08"};
    }


}


export function getTrendIcon(item, positive) {
/*    if (item > 0) {
        if (positive) {
            return <TrendingUpIcon sx={{color: "#e70a08"}}/>
        } else {
            return <TrendingUpIcon sx={{color: "#0fa64e"}}/>
        }
    } else if (item < 0) {
        if (positive) {
            return <TrendingDownIcon sx={{color: "#0fa64e"}}/>
        } else {
            return <TrendingDownIcon sx={{color: "#e70a08"}}/>
        }

    }*/
    if (item > 0) {
        if (positive) {
            return <TrendingUpIcon/>
        } else {
            return <TrendingUpIcon/>
        }
    } else if (item < 0) {
        if (positive) {
            return <TrendingDownIcon/>
        } else {
            return <TrendingDownIcon/>
        }

    }
    return <HorizontalRuleIcon/>;
}


export function getDataCity() {
    return {
        resultats: {
            inscrits: {
                2020: {nb: 1287, trendPerc: 0.032, trend: "up"},
                2014: {nb: 1247, trendPerc: 0.084, trend: "up"},
                2008: {nb: 1150, trendPerc: null, trend: "up"},
            },
            abstentions: {
                2020: {
                    t1: {nb: 1287, perc: 0.032, trendPerc: null, trend: "up"}
                },
                2014: {
                    t1: {nb: 1200, perc: 0.032, trendPerc: null, trend: "down"},
                    t2: {nb: 1087, perc: 0.032, trendPerc: 0.032, trend: "up"}
                },
                2008: {
                    t1: {nb: 687, perc: 0.032, trendPerc: null, trend: "down"},
                    t2: {nb: 987, perc: 0.032, trendPerc: 0.032, trend: "up"}
                },
            },
            blancs: {
                2020: {
                    t1: {nb: 1287, perc: 0.032, trendPerc: null, trend: "up"}
                },
                2014: {
                    t1: {nb: 1200, perc: 0.032, trendPerc: null, trend: "down"},
                    t2: {nb: 1087, perc: 0.032, trendPerc: 0.032, trend: "up"}
                },
                2008: {
                    t1: {nb: 687, perc: 0.032, trendPerc: null, trend: "down"},
                    t2: {nb: 987, perc: 0.032, trendPerc: 0.032, trend: "up"}
                },
            },
            nuls: {
                2020: {
                    t1: {nb: 1287, perc: 0.032, trendPerc: null, trend: "up"}
                },
                2014: {
                    t1: {nb: 1200, perc: 0.032, trendPerc: null, trend: "down"},
                    t2: {nb: 1087, perc: 0.032, trendPerc: 0.032, trend: "up"}
                },
                2008: {
                    t1: {nb: 687, perc: 0.032, trendPerc: null, trend: "down"},
                    t2: {nb: 987, perc: 0.032, trendPerc: 0.032, trend: "up"}
                },
            }
        },
        total: 2000,
        canddiats: {
            2020: {
                t1: {
                    bob1: {nb: 1287, perc: 0.532, nomPrenom: "bob1", nuance: "LR"},
                    bob12: {nb: 1287, perc: 0.032, nomPrenom: "bob12", nuance: "LR"},
                    bob13: {nb: 1287, perc: 0.032, nomPrenom: "bob13", nuance: "LR"},
                    bob14: {nb: 1287, perc: 0.032, nomPrenom: "bob14", nuance: "LR"},
                }
            },
            2014: {
                t1: {
                    bob1: {nb: 1287, perc: 0.532, nomPrenom: "bob1", nuance: "LR"},
                    bob12: {nb: 1287, perc: 0.032, nomPrenom: "bob12", nuance: "LR"},
                    bob13: {nb: 1287, perc: 0.032, nomPrenom: "bob13", nuance: "LR"},
                    bob14: {nb: 1287, perc: 0.032, nomPrenom: "bob14", nuance: "LR"},
                },
                t2: {
                    bob1: {nb: 1287, perc: 0.532, nomPrenom: "bob1", nuance: "LR"},
                    bob12: {nb: 1287, perc: 0.032, nomPrenom: "bob12", nuance: "LR"},
                    bob13: {nb: 1287, perc: 0.032, nomPrenom: "bob13", nuance: "LR"},
                    bob14: {nb: 1287, perc: 0.032, nomPrenom: "bob14", nuance: "LR"},
                }
            },
            2008: {
                t1: {
                    bob1: {nb: 1287, perc: 0.532, nomPrenom: "bob1", nuance: "LR"},
                    bob12: {nb: 1287, perc: 0.032, nomPrenom: "bob12", nuance: "LR"},
                    bob13: {nb: 1287, perc: 0.032, nomPrenom: "bob13", nuance: "LR"},
                    bob14: {nb: 1287, perc: 0.032, nomPrenom: "bob14", nuance: "LR"},
                },
                t2: {
                    bob1: {nb: 1287, perc: 0.532, nomPrenom: "bob1", nuance: "LR"},
                    bob12: {nb: 1287, perc: 0.032, nomPrenom: "bob12", nuance: "LR"},
                    bob13: {nb: 1287, perc: 0.032, nomPrenom: "bob13", nuance: "LR"},
                    bob14: {nb: 1287, perc: 0.032, nomPrenom: "bob14", nuance: "LR"},
                }
            },
        },

        nuances: {
            2020: {
                t1: {
                    LR1: {nb: 1287, perc: 0.532, nuance: "LR1"},
                    LR2: {nb: 1287, perc: 0.032, nuance: "LR2"},
                    LR3: {nb: 1287, perc: 0.032, nuance: "LR3"},
                    LR4: {nb: 1287, perc: 0.032, nuance: "LR4"},
                }
            },
            2014: {
                t1: {
                    LR1: {nb: 1287, perc: 0.532, nuance: "LR1"},
                    LR2: {nb: 1287, perc: 0.032, nuance: "LR2"},
                    LR3: {nb: 1287, perc: 0.032, nuance: "LR3"},
                    LR4: {nb: 1287, perc: 0.032, nuance: "LR4"},
                },
                t2: {
                    LR1: {nb: 1287, perc: 0.532, nuance: "LR1"},
                    LR2: {nb: 1287, perc: 0.032, nuance: "LR2"},
                    LR3: {nb: 1287, perc: 0.032, nuance: "LR3"},
                    LR4: {nb: 1287, perc: 0.032, nuance: "LR4"},
                }
            },
            2008: {
                t1: {
                    LR1: {nb: 1287, perc: 0.532, nuance: "LR1"},
                    LR2: {nb: 1287, perc: 0.032, nuance: "LR2"},
                    LR3: {nb: 1287, perc: 0.032, nuance: "LR3"},
                    LR4: {nb: 1287, perc: 0.032, nuance: "LR4"},
                },
                t2: {
                    LR1: {nb: 1287, perc: 0.532, nuance: "LR1"},
                    LR2: {nb: 1287, perc: 0.032, nuance: "LR2"},
                    LR3: {nb: 1287, perc: 0.032, nuance: "LR3"},
                    LR4: {nb: 1287, perc: 0.032, nuance: "LR4"},
                }
            },
        },
        persona: {
            popCsp: {
                mostDynamic: [
                    {name: "Pop 18-24", nb: 1287, perc: 0.532, trendPerc: 0.032, trend: "up", color: "#ff0000"},
                    {name: "Pop 25-34", nb: 1287, perc: 0.032, trendPerc: 0.032, trend: "up", color: "#ff0000"}
                ],
                mostRepresentative: [
                    {name: "Pop 18-24", nb: 1287, perc: 0.532, trendPerc: 0.032, trend: "up", color: "#ff0000"},
                    {name: "Pop 25-34", nb: 1287, perc: 0.032, trendPerc: 0.032, trend: "up", color: "#ff0000"}
                ]
            }
        }

    }
}

export const getLastDateElection = {
    muni: 2020,
    legi: 2024
}
export const getNomElection2 = {
    muni: "municipale",
    legi: "législative",
    reg: "régionale",
    dep: "départementale",
    eur: "européenne",
}
export const getNomElection = {
    muni: "Municipales",
    legi: "Législatives",
    reg: "Régionales",
    dep: "Départementales",
    eur: "Européennes",
}

export function getColor(status) {
    let color = "#e70a08";
    if (status === "winner") {
        color = "#0fa64e"
    } else if (status === "winnerJuste") {
        color = "#86c14d"
    } else if (status === "winnerPeu") {
        color = "#eeb408"
    }
    return color
}

export function getIconById(id, color, fontS) {
    if (fontS) {
        fontS = 20;
    }
    switch (id) {
        case 0:
            return <Brightness1Icon sx={{color: color, fontSize: fontS}}/>;
        case 1:
            return <ChangeHistoryIcon sx={{color: color, fontSize: fontS}}/>;
        case 3:
            return <CropSquareIcon sx={{color: color, fontSize: fontS}}/>;
        case 4:
            return <SquareIcon sx={{color: color, fontSize: fontS}}/>;
        case 5:
            return <StopCircleIcon sx={{color: color, fontSize: fontS}}/>;
        case 6:
            return <InterestsIcon sx={{color: color, fontSize: fontS}}/>;
        case 7:
            return <DisabledByDefaultIcon sx={{color: color, fontSize: fontS}}/>;
        case 8:
            return <AcUnitIcon sx={{color: color, fontSize: fontS}}/>;
        case 9:
            return <AccessibilityIcon sx={{color: color, fontSize: fontS}}/>;
        case 10:
            return <ViewInArIcon sx={{color: color, fontSize: fontS}}/>;
        default:
            return <AccountBalanceIcon sx={{color: color, fontSize: fontS}}/>;
    }
}

export function correctId(bvId) {
    const splitKey = bvId.split("_");
    return splitKey[0].padStart(5, '0') + "_" + splitKey[1].padStart(4, '0');
}


export const tddDelay = ms => new Promise(res => setTimeout(res, ms));
